<template>
  <section id="about" class="br-b-white text-black bg-white pd-big">
    <h2 class="motto" itemprop="name">
      <span class="text-fade-in">
          <span class="text-splitted">{{text}}</span>
      </span>
    </h2>
    <meta itemprop="description" :content="text">
  </section>
</template>

<script setup>
/////////////////////////////
// COMPONENT DEPENDENCIES
/////////////////////////////
// Data
// USED COMPONENTS
// VUE DEPENDENCIES
import { toRefs, onMounted } from 'vue';
// GSAP DEPENDENCIES
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
/////////////////////////////
// CREATED
/////////////////////////////
gsap.registerPlugin(ScrollTrigger);

const props = defineProps({
  theme: String,
  text: {
    type: String,
    default: "Relax and Enjoy in  Phuket's Most  Stylish Bar and Terrace"
  }
});

const { theme } = toRefs(props);

/////////////////////////////
// MOUNTED
/////////////////////////////
onMounted(() => {
	gsap.set('.skillset', {
    // maxHeight: 0,
    force3D:false,
    opacity: 0,
    // y: 50,
  });

  gsap.set('.skillset-child ', {
    opacity: 0,
    force3D:false,
    y: 50,
  }); 

 ScrollTrigger.batch('.skillset', {
  onEnter: batch => {
    batch.forEach((card, index) => {
      gsap.to(card, {
        opacity: 1,
        // maxHeight: 1000, 
        duration: 1.5,
        ease: "power2.inOut",
        y: 0, 
        stagger: 0.1, 
        delay: index * 0.3
      })

      gsap.to(card.children, {
        opacity: 1, 
        duration: 1.5,
        ease: "power2.inOut",
        y: 0, 
        stagger: 0.1, 
        delay: index * 0.3
      })
    })
  },
  // onLeaveBack: batch => {
  //   batch.forEach((card, index) => gsap.to(card.children, {
  //     opacity: 0, 
  //     duration: 1.5,
  //     ease: "power2.inOut",
  //     y: 50, 
  //     stagger: 0.1, 
  //     delay: index * 0.3
  //   }))
  // },
  start: "top 70%",
  });

})

</script>

<style lang="scss">
.motto {
  font-size: 9rem;
}
  @media screen and (max-width: 1280px) {
    .motto {
      font-size: 5rem;
    }
  }
</style>